.actionButtons {
  display: flex;
  justify-content: center;
}

.actionButtons button {
  margin: 0 5px;
}
